<app-master-data-table [data]="masterCommonService.mtcTypesList" [columns]="mtctypeColumns" title="Mtc Types List"
  addButtonLabel="MTC Type" (add)="openAddUpdateMtcTypeDialog('add')"
  (update)="openAddUpdateMtcTypeDialog('update', $event)" (delete)="deleteMtcType($event)">
</app-master-data-table>